import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/core';
import { IDuplicateAccount } from '@app/models/signup';

@Component({
  selector: 'duplicate-organisation-dialog',
  templateUrl: './duplicate-organisation.component.html',
  styleUrls: ['./duplicate-organisation.component.scss']
})

export class SignupDuplicateOrganisationDialogComponent {

  accountName: string;
  duplicateAccounts: Partial<IDuplicateAccount>[] = [];
  language: any;

  constructor(private dialogRef: MatDialogRef<SignupDuplicateOrganisationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any, private lang: I18nService) {
        console.log('data', data);
    this.accountName = data.accountName;
    this.duplicateAccounts = data.duplicateAccounts;
    this.language = this.lang.language;
  }

  selectOwner() {
    const endpoint = (window['ENDPOINTS'] && window['ENDPOINTS'].login) || 'login.infomaniak.com';
    window.location.assign(endpoint);
  }

  close() {
    this.dialogRef.close();
  }







}
